import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import Component from '../Component'
import { getTeamUrl } from 'Common'
import { 
  handleFetchSettings,
  handleFetchRuns,
  handleFetchRunDetails,
  handleTableChange,
  handleManualTBTRun,
  handleFetchDocuments,
  handleUploadDocument,
  handleDeleteDocument,
  handleToggleDocumentActive,
  handleFetchStatistics,
} from '../Handlers'

const mapStateToProps = (state) => ({
  settings: state.screens.ToolBoxTalk.settings.data,
  settingsLoading: state.screens.ToolBoxTalk.settings.fetching,
  runs: state.screens.ToolBoxTalk.runs.data,
  runsLoading: state.screens.ToolBoxTalk.runs.fetching,
  pagination: state.screens.ToolBoxTalk.runs.pagination,
  runDetails: state.screens.ToolBoxTalk.runDetails.data,
  isRunning: state.screens.ToolBoxTalk.manualRun.loading,
  manualRunResult: state.screens.ToolBoxTalk.manualRun.data,
  manualRunError: state.screens.ToolBoxTalk.manualRun.error,
  documents: state.screens.ToolBoxTalk.documents.data,
  documentsLoading: state.screens.ToolBoxTalk.documents.fetching,
  documentsUploading: state.screens.ToolBoxTalk.documents.uploading,
  statistics: state.screens.ToolBoxTalk.statistics.data,
  statisticsLoading: state.screens.ToolBoxTalk.statistics.fetching,
})

const mapDispatchToProps = (dispatch) => ({
  componentDidMount: () => {
    dispatch(handleFetchSettings())
    dispatch(handleFetchRuns({ page: 1, per_page: 20 }))
    dispatch(handleFetchStatistics())
  },
  onChangeTable: (pagination, filters, sorter) => {
    dispatch(handleTableChange(pagination, filters, sorter))
  },
  onViewRunDetails: (runId) => {
    dispatch(handleFetchRunDetails(runId))
  },
  onRefreshRuns: () => {
    dispatch((dispatch, getState) => {
      const state = getState()
      const currentPagination = state.screens.ToolBoxTalk.runs.pagination || {}
      const params = {
        page: currentPagination.current || 1,
        per_page: currentPagination.pageSize || 20
      }
      dispatch(handleFetchRuns(params))
    })
  },
  onClickSettings: () => {
    // Navigate to Settings screen with Tool Box Talks group pre-selected
    dispatch(push(getTeamUrl('settings?group=Tool Box Talks')))
  },
  onManualRun: () => {
    return dispatch(handleManualTBTRun())
  },
  onFetchRuns: (params) => {
    return dispatch(handleFetchRuns(params))
  },
  onFetchDocuments: (params) => {
    return dispatch(handleFetchDocuments(params))
  },
  onUploadDocument: (formData) => {
    return dispatch(handleUploadDocument(formData))
  },
  onDeleteDocument: (id) => {
    return dispatch(handleDeleteDocument(id))
  },
  onToggleDocumentActive: (id) => {
    return dispatch(handleToggleDocumentActive(id))
  },
  onFetchStatistics: () => {
    return dispatch(handleFetchStatistics())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
